export enum FinancialStatementMonthVisualizationTypes {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY'
}
